import SvgIcon from '@mui/material/SvgIcon';

const RocketIcon = (props) => {
  return (
    <SvgIcon
      {...props}
      width="21"
      height="22"
      viewBox="0 0 21 22"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        width: props.width ?? '21px',
        height: props.height ?? '22px',
        fill: props.fill ?? 'none',
        alignItems: 'center',
      }}
    >
      <g clipPath="url(#clip0_6018_9629)">
        <path
          d="M16.6803 10.4709C15.469 11.7349 10.7578 15.5267 10.7578 15.5267"
          stroke="#212427"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.6812 10.4715C19.9135 7.09874 19.9135 4.85718 19.9135 1.48438C16.6812 1.48438 14.5331 1.48438 11.3008 4.85718"
          stroke="#212427"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.6811 10.4709L17.4039 14.2558C17.6247 15.401 17.2767 16.5811 16.4871 17.4121L14.0712 19.933C13.7567 20.2612 13.228 20.1844 13.0139 19.7793L10.752 15.5337"
          stroke="#212427"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.3021 4.85718L6.45703 11.0372"
          stroke="#212427"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.2993 4.85669L7.67218 4.10253C6.57468 3.87209 5.44371 4.2352 4.64736 5.0592L2.23152 7.58008C1.91699 7.90828 1.9906 8.45994 2.37874 8.6834L6.44753 11.0437"
          stroke="#212427"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.45703 11.0359L10.7667 15.526"
          stroke="#212427"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.0677 6.53955L13.9902 7.66382"
          stroke="#F8C408"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.60938 20.584L5.91908 19.6832C6.54144 19.5505 6.9965 18.9779 6.9965 18.3145V16.3593C6.9965 15.5911 6.39421 14.9626 5.65808 14.9626H3.7843C3.14855 14.9626 2.5998 15.4305 2.47265 16.0869L1.60938 20.584Z"
          stroke="#F8C608"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6018_9629">
          <rect
            width="19.6413"
            height="20.4952"
            fill="white"
            transform="translate(0.941406 0.7854)"
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export default RocketIcon;
